import React from "react";
import { bool, string, func } from "prop-types";

import "./radioButton.m.css";

const RadioButton = ({ isChecked, text, type, name, value, onClick }) => (
  <label styleName="wrapper">
    <span styleName={isChecked ? "selected" : ""}>{text}</span>
    <input type="radio" defaultChecked={isChecked} onClick={onClick} value={value} name={name} />
    <span styleName={type}></span>
  </label>
);

RadioButton.defaultProps = {
  type: "type1",
  name: "radiobtn",
  isChecked: false
};

RadioButton.propTypes = {
  isChecked: bool,
  text: string,
  value: string,
  name: string,
  type: string,
  onClick: func
};

export default RadioButton;
